import { transparentize } from 'polished';
var COR_PRIMARIA_PADRAO = '#003B82';
// Cor primária da empresa (white-label) com fallback, como no App.
export var corPrimaria = function (theme) { return (theme === null || theme === void 0 ? void 0 : theme.corPrimaria) || COR_PRIMARIA_PADRAO; };
// Tom suave da cor primária para fundos; cor inválida cai no padrão em vez de quebrar a tela.
export var corPrimariaSuave = function (theme, intensidade) {
    if (intensidade === void 0) { intensidade = 0.88; }
    try {
        return transparentize(intensidade, corPrimaria(theme));
    }
    catch (_a) {
        return transparentize(intensidade, COR_PRIMARIA_PADRAO);
    }
};
